import FocusableBackButton from '@components/FocusableBackButton';
import { useAgreementContext } from '@context/Agreement';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import AgreementAllButtons from './components/AgreementAllButtons';
import Content from './components/Content';
import SpecificFourAgreementButtons from './components/SpecificFourAgreementButtons';

import * as styles from './styles';

const Agreement = () => {
  const { goPaymentSelection, isSpecificAgreementOpened } = useAgreementContext();

  const { focusKey } = useFocusable();

  return (
    <FocusContext.Provider value={focusKey}>
      <div css={styles.container}>
        <div css={styles.leftSideContainer}>
          <FocusableBackButton onEnterPress={goPaymentSelection} />
          <Content />
        </div>
        <div css={styles.rightSideContainer}>
          {isSpecificAgreementOpened ? (
            <SpecificFourAgreementButtons />
          ) : (
            <AgreementAllButtons />
          )}
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default Agreement;
